import { Injectable, inject } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class RedirectGuard implements CanActivate {
  private router = inject(Router);

  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      if(window.location.href.toLocaleLowerCase().startsWith('https://wida-status')){
          window.location.href = route.data['widaRedirectUrl'];
          return false;
      }else{
        return true;
      }

  }
} 